/* global HTMLElement, customElements */

import * as focusTrap from 'focus-trap'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { tabbable } from 'tabbable'

class DrawerElement extends HTMLElement {
  constructor () {
    super()

    this.$scrollArea = this.querySelector('.js-drawer__scrollarea')
    this.$toggle = this.querySelector('.js-drawer__toggle')
    this.$toggle.addEventListener('click', () => this.close())

    this.focusTrap = focusTrap.createFocusTrap(this, {
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      onDeactivate: () => {
        this.close()
      },
      initialFocus: () => {
        this.focus()
        return false
      }
    })

    this.initBackdrop()
    this.addEventListener('transitionend', (e) => {
      if (!this.open && e.propertyName === 'visibility') {
        this.dispatchEvent(new CustomEvent('drawer:hidden'))
      } else if (this.open) {
        this.dispatchEvent(new CustomEvent('drawer:shown'))
      }
    })

    this.style.setProperty('transition', 'none', 'important')
    setTimeout(() => this.style.removeProperty('transition'))
  }

  connectedCallback () {
    document.body.insertAdjacentElement('beforeend', this.$backdrop)
  }

  disconnectedCallback () {
    document.body.removeChild(this.$backdrop)
  }

  adoptedCallback () {
    document.body.appendChild(this.$backdrop)
  }

  toggle (force) {
    const oldState = this.open
    const newState = (typeof force !== 'undefined') ? force : !this.open

    if (oldState === newState) {
      return
    }

    this.$backdrop.classList.toggle('is-open', newState)
    this.classList.toggle('is-open', newState)

    if (newState === true) {
      this.dispatchEvent(new CustomEvent('drawer:show'))
      this.focusTrap.activate()
      disableBodyScroll(this.$scrollArea)

      for (const $el of tabbable(this)) {
        if ($el !== this.$toggle) {
          $el.focus()
        }
      }
    } else {
      this.dispatchEvent(new CustomEvent('drawer:hide'))
      this.focusTrap.deactivate()
      enableBodyScroll(this.$scrollArea)
    }
  }

  initBackdrop () {
    this.$backdrop = document.createElement('div')
    this.$backdrop.className = 'drawer__backdrop'
  }

  get open () {
    this.classList.contains('is-open')
  }

  show () {
    return this.toggle(true)
  }

  close () {
    return this.toggle(false)
  }
}

customElements.define('x-drawer', DrawerElement)
